module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.25458",
      "conversations-internal-schema": "static-1.12283",
      "head-dlb": "static-1.4702",
      "hs-test-utils": "static-1.7641",
      "hubspot-url-utils": "static-1.3825",
      "HubStyleTokens": "static-2.11074",
      "I18n": "static-7.1528",
      "jasmine-runner": "static-1.6110",
      "quartz": "static-1.6519",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.481",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.5782",
      "enviro": "static-4.371",
      "hs-promise-rejection-tracking": "static-1.5234",
      "PortalIdParser": "static-2.334",
      "raven": "static-3.5564",
      "raven-hubspot": "static-1.5871",
      "bend-plugin-trellis-migration": "static-1.3094",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1430",
      "hub-http": "static-1.5872",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4307",
      "quartz-config": "static-1.297",
      "quartz-core": "static-1.5738",
      "transmute": "static-2.77",
      "HeadJS": "static-2.679",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7207",
      "framer-motion": "static-1.62",
      "hs-test-utils-bend-plugin": "static-1.2752",
      "msw": "static-1.39",
      "react-redux": "static-7.65",
      "redux": "static-4.16",
      "testing-library": "static-1.144",
      "foundations-theming": "static-1.4057",
      "i18n-data": "static-1.214",
      "metrics-js": "static-1.9296",
      "moment-timezone": "static-5.76",
      "react-utils": "static-2.5046",
      "jasmine": "static-4.3989",
      "history": "static-4.47",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.58",
      "styled-components": "static-2.83",
      "UIComponents": "static-3.8021",
      "visitor-ui-component-library-icons": "static-1.5593",
      "bender-build-tools": "static-1.2756",
      "rpc-client-utils": "static-1.4260",
      "ts-schema": "static-1.3771",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.129",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.759",
      "hubspotter-http": "static-1.4344",
      "icons": "static-2.601",
      "mobile-manifest-mixins": "static-1.452",
      "quartz-auth": "static-1.194",
      "quartz-head": "static-1.184",
      "quartz-i18n": "static-1.194",
      "quartz-test": "static-1.194",
      "quick-fetch": "static-1.3595",
      "react-rhumb": "static-1.16281",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.337",
      "bend-plugin-foundations-components": "static-1.3476",
      "floating-ui": "static-1.49",
      "foundations-assets": "static-1.4485",
      "foundations-theming-specialty": "static-1.1773",
      "hs-story-utils": "static-1.9087",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.91",
      "tanstack-table": "static-1.48",
      "trellis-assets": "static-1.901",
      "ui-images": "static-2.1042",
      "bend-plugin-foundations-theming": "static-1.2540",
      "foundations-theming-base": "static-1.3042",
      "stylex": "static-1.25",
      "classnames": "static-2.10",
      "cssUtils": "static-1.683",
      "HubStyle": "static-2.11382",
      "sassPrefix": "static-1.149",
      "hub-http-shared-msw-handlers": "static-1.9119",
      "hubspotter-http-shared-msw-handlers": "static-1.9117",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.25458",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12283",
      "head-dlb": "/head-dlb/static-1.4702",
      "hs-test-utils": "/hs-test-utils/static-1.7641",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
      "HubStyleTokens": "/HubStyleTokens/static-2.11074",
      "I18n": "/I18n/static-7.1528",
      "jasmine-runner": "/jasmine-runner/static-1.6110",
      "quartz": "/quartz/static-1.6519",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.481",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5782",
      "enviro": "/enviro/static-4.371",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
      "PortalIdParser": "/PortalIdParser/static-2.334",
      "raven": "/raven/static-3.5564",
      "raven-hubspot": "/raven-hubspot/static-1.5871",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3094",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1430",
      "hub-http": "/hub-http/static-1.5872",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4307",
      "quartz-config": "/quartz-config/static-1.297",
      "quartz-core": "/quartz-core/static-1.5738",
      "transmute": "/transmute/static-2.77",
      "HeadJS": "/HeadJS/static-2.679",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7207",
      "framer-motion": "/framer-motion/static-1.62",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2752",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.65",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.144",
      "foundations-theming": "/foundations-theming/static-1.4057",
      "i18n-data": "/i18n-data/static-1.214",
      "metrics-js": "/metrics-js/static-1.9296",
      "moment-timezone": "/moment-timezone/static-5.76",
      "react-utils": "/react-utils/static-2.5046",
      "jasmine": "/jasmine/static-4.3989",
      "history": "/history/static-4.47",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.58",
      "styled-components": "/styled-components/static-2.83",
      "UIComponents": "/UIComponents/static-3.8021",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5593",
      "bender-build-tools": "/bender-build-tools/static-1.2756",
      "rpc-client-utils": "/rpc-client-utils/static-1.4260",
      "ts-schema": "/ts-schema/static-1.3771",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.129",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.759",
      "hubspotter-http": "/hubspotter-http/static-1.4344",
      "icons": "/icons/static-2.601",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.452",
      "quartz-auth": "/quartz-auth/static-1.194",
      "quartz-head": "/quartz-head/static-1.184",
      "quartz-i18n": "/quartz-i18n/static-1.194",
      "quartz-test": "/quartz-test/static-1.194",
      "quick-fetch": "/quick-fetch/static-1.3595",
      "react-rhumb": "/react-rhumb/static-1.16281",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.337",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3476",
      "floating-ui": "/floating-ui/static-1.49",
      "foundations-assets": "/foundations-assets/static-1.4485",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1773",
      "hs-story-utils": "/hs-story-utils/static-1.9087",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.91",
      "tanstack-table": "/tanstack-table/static-1.48",
      "trellis-assets": "/trellis-assets/static-1.901",
      "ui-images": "/ui-images/static-2.1042",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2540",
      "foundations-theming-base": "/foundations-theming-base/static-1.3042",
      "stylex": "/stylex/static-1.25",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.683",
      "HubStyle": "/HubStyle/static-2.11382",
      "sassPrefix": "/sassPrefix/static-1.149",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9119",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9117",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};